import type { GameId } from '@xox/shared'
import { ArrowRight } from 'lucide-react'
import { useNavigate } from 'react-router'
import { GAMES, ROOM_PATHS } from '../lib/games'
import { Button, Card } from './ui'

/** "You have a game in progress" banner for one of the viewer's open duel rooms. */
export function ResumeCard({ game, code }: { game: GameId; code: string }) {
  const navigate = useNavigate()
  const title = GAMES.find((g) => g.to === `/${game}`)?.title ?? game
  return (
    <Card className="flex items-center justify-between gap-3 border-l-4 border-l-emerald-500">
      <div>
        <div className="text-sm font-semibold">{title} in progress</div>
        <div className="font-mono text-xs text-slate-500">Room {code}</div>
      </div>
      <Button variant="secondary" onClick={() => navigate(`${ROOM_PATHS[game]}/${code}`)}>
        Resume <ArrowRight className="size-4" aria-hidden />
      </Button>
    </Card>
  )
}
